import { render, staticRenderFns } from "./ModalAccept.vue?vue&type=template&id=551456d5&"
import script from "./ModalAccept.vue?vue&type=script&lang=js&"
export * from "./ModalAccept.vue?vue&type=script&lang=js&"
import style0 from "./ModalAccept.vue?vue&type=style&index=0&id=551456d5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports